import { QueryCache, QueryClient } from "@tanstack/react-query";
import axios from "axios";

import { isSearchExpiredError } from "@/utils/assertions";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (axios.isAxiosError(error)) {
          if (
            error.code === "ERR_NETWORK" ||
            error.code === "ENOTFOUND" ||
            error.code === "ECONNREFUSED" ||
            error.code === "ECONNABORTED" ||
            error.code === "ETIMEDOUT"
          ) {
            return failureCount < 5; // Limit network errors to 5 attempts
          }

          if (error.response && error.response.status >= 500) {
            return failureCount < 2; // Limit 5xx retries to 2 attempts
          }
        }

        // Other types (like 4xx errors) should not be retried
        return false;
      },
      retryDelay: (attemptIndex) => Math.min(500 * 2 ** attemptIndex, 5000), // Exponential backoff: 500ms, 1s, 2s, 4s, 5s (max)
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      networkMode: "always",
      throwOnError: (error) => !isSearchExpiredError(error),
    },
  },
  queryCache: new QueryCache({
    onError(error) {
      if (isSearchExpiredError(error)) {
        window.dispatchEvent(new CustomEvent("searchresultsexpired"));
      }
    },
  }),
});
